import style from "./style.scss";
import { mergeClasses } from "../helpers";
import { Fragment } from "preact";

const Hero = ({
  background = null,
  positionX = null,
  positionY = null,
  thumbnail = null,
  short = false,
  titlePrefix = null,
  title = null,
  subTitle = null,
  children = null,
}) => {
  const backgroundPositionX =
    positionX >= 0 && positionX <= 100
      ? `background-position-x: ${positionX}%;`
      : "";
  const backgroundPositionY =
    positionY >= 0 && positionY <= 100
      ? `background-position-y: ${positionY}%;`
      : "";

  // TODO: Use to preload header image
  // <link
  //   rel="preload"
  //   fetchpriority="high"
  //   as="image"
  //   href="hero.webp"
  //   type="image/webp">

  return (
    <div
      class={mergeClasses(
        background
          ? [style.imgHero, "dark", short ? style.short : null]
          : [style.textHero]
      )}
      style={
        background
          ? `background-image: url('${background}');${backgroundPositionX}${backgroundPositionY}`
          : null
      }
    >
      <div class={style.wrapper}>
        <div
          class={mergeClasses([
            style.content,
            thumbnail ? style.hasThumbnail : null,
          ])}
        >
          {thumbnail && (
            <div class={style.thumbnail}>
              <img src={thumbnail} />
            </div>
          )}
          {title ? (
            <h1 class={style.titleGroup}>
              {titlePrefix && (
                <span class={style.prefix}>{`${titlePrefix} `}</span>
              )}
              <span class={style.lineGroup}>
                <span class={style.title}>{title}</span>
                {subTitle && (
                  <span class={style.subTitle}>
                    <span class={style.colon}>:</span> {subTitle}
                  </span>
                )}
              </span>
            </h1>
          ) : (
            children
          )}
        </div>
      </div>
    </div>
  );
};

export default Hero;
